import React from 'react';
import { ProductFilters } from '../../../../app/models/Product';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
  filter: ProductFilters;
  setFilter: (filter: ProductFilters) => void;
  onSearch: () => void;
};

// Claves del filtro que reciben strings desde inputs/selects
type TextFilterKey =
  | 'name'
  | 'sector'
  | 'category'
  | 'ownership_type'
  | 'origin'
  | 'quality'
  | 'color'
  | 'unit'
  | 'sale_name'
  | 'purchase_name';

const ProductFilter = ({ filter, setFilter, onSearch }: Props) => {
  const handleIdChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const raw = e.target.value;
    const parsed = raw === '' ? null : Number(raw);

    setFilter({
      ...filter,
      page: 1,
      id: Number.isNaN(parsed) ? null : parsed,
    } as ProductFilters);
  };

  const handlerInputFilter = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const key = name as TextFilterKey;

    setFilter({
      ...filter,
      page: 1,           // vuelve a la primera página
      [key]: value,      // sin `any`
    } as ProductFilters);
  };

  const doSearch = (e?: React.FormEvent) => {
    e?.preventDefault?.();
    onSearch();
  };

  return (
    <form onSubmit={doSearch}>
      {/* ...tu mismo JSX de inputs/selects... */}
      <div className="row">
        {/* Id */}
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1" htmlFor="id">Id</label>
            <input
              title="Id"
              type="number"
              id="id"
              name="id"
              className="form-control form-control-sm"
              value={filter.id ?? ''}
              onChange={handleIdChange}
            />
          </div>
        </div>

        {/* Nombre */}
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1" htmlFor="name">Nombre</label>
            <input
              title="Nombre"
              type="text"
              id="name"
              name="name"
              className="form-control form-control-sm"
              value={filter.name ?? ''}
              onChange={handlerInputFilter}
            />
          </div>
        </div>

        {/* Sector */}
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1" htmlFor="sector">Sector</label>
            <input
              title="Sector"
              type="text"
              id="sector"
              name="sector"
              className="form-control form-control-sm"
              value={filter.sector ?? ''}
              onChange={handlerInputFilter}
            />
          </div>
        </div>

        {/* Categoría */}
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1" htmlFor="category">Categoría</label>
            <input
              title="Categoría"
              type="text"
              id="category"
              name="category"
              className="form-control form-control-sm"
              value={filter.category ?? ''}
              onChange={handlerInputFilter}
            />
          </div>
        </div>

        {/* Tipo Propiedad */}
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1" htmlFor="ownership_type">Tipo de Propiedad</label>
            <select
              id="ownership_type"
              name="ownership_type"
              className="form-control form-control-sm"
              value={filter.ownership_type ?? ''}
              onChange={handlerInputFilter}
              title="Tipo de Propiedad"
            >
              <option value="">Todos</option>
              <option value="OWN">Propio</option>
              <option value="OWN_THIRD_PARTY">Propio con material de Tercero</option>
              <option value="THIRD_PARTY">De Tercero</option>
            </select>
          </div>
        </div>

        {/* Unidad */}
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1" htmlFor="unit">Unidad</label>
            <input
              title="Unidad"
              type="text"
              id="unit"
              name="unit"
              className="form-control form-control-sm"
              value={filter.unit ?? ''}
              onChange={handlerInputFilter}
              placeholder="Nombre de la unidad"
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div style={{ marginTop: '22px' }}>
            <ButtonSearchFilter callbackSearch={doSearch} />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ProductFilter;
